import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import Done from "./Done/container";
import Unsubscribe from "./Unsubscribe/container";
import { getSidFromQS } from "./lib";

import "./style.less";

export type MapProps = RootContainerProps & {
  isEditMode: boolean;
  status: string;
  step: number;
};

export interface ActionProps {}
export type Props = ActionProps & MapProps;

export default ({ status, step, ...rootProps }: Props) => {
  if (!getSidFromQS() && !rootProps.isEditMode) return null;

  return (
    <Container className="wsc_content_unsubscribe" {...getContainerProps(rootProps)}>
      {step === 1 && <Unsubscribe {...rootProps} />}
      {step === 2 && <Done {...rootProps} />}
    </Container>
  );
};
